import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IOrderHistoryDto } from 'src/app/models/backend/order-histories';
import { PagedListingComponentBase } from 'src/app/shared/components/paged-listing-component-base';
import { BalanceHistoriesService } from '../balance-histories/balance-histories.service';
import { Router } from '@angular/router';
import { IPagedOrderHistoryResultRequestDto } from 'src/app/models/backend';
import { OrderHistoryService } from './order-history.service';
import { RetailersService } from '../retailers/retailers.service';
import { OrderItemsComponent } from './order-items/order-items.component';
import { UpdateOrderStatusComponent } from './update-order-status/update-order-status.component';
import { saveAs } from 'file-saver';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { ToastrService } from 'ngx-toastr';
import { LoginService } from '../login/login.service';
import { environment } from 'src/environments/environment';
import { ControlItem } from 'src/app/models/frontend';
import {  OrderStatus,OrderStatusData, UserRole } from 'src/app/models/enums';

@Component({
  selector: 'app-order-history',
  templateUrl: './order-history.component.html',
  styleUrls: ['./order-history.component.scss'],
})
export class OrderHistoryComponent extends PagedListingComponentBase<IOrderHistoryDto>  {
  protected override delete(entity: IOrderHistoryDto): void {
    throw new Error('Method not implemented.');
  }

  myModel: any;
  keyword: any = '';
  categorySortingTypes: any[] = [];
  selectedCategorySortingTypes: number | null = 2;
  boolCustom = false;
  request: any = {
    skipCount: 0,
    maxResultCount: 10,
    keyword: '',
    isInvoledDeletedItems: true,
    isTestMode: true,
  };
  @Output('updated') updated = new EventEmitter<boolean>();
  loader = false;
  startDate: Date = new Date();
  endDate: Date = new Date();
 
  Role: any;
  Retailers: any;
  filterRetailer: any;
  ddlRetailer: any;
  retailerId: any;

  OrderCounts: any;
  data: any;
  totalItemsCount = 0;
  allrecords=[];
  showOrderDetails:boolean = false;
  constructor(
    private modalService: NgbModal,
    private service: OrderHistoryService,
    public router: Router,
    public retailerService: RetailersService,
    private dialog: MatDialog,
    public loginService: LoginService
  ) {
    super();
    this.Role = localStorage.getItem('RoleType');
    this.getRetailers();
    const today = new Date().toISOString().split('T')[0]; // Get today's date
    this.startDate = new Date();
    this.endDate = new Date();
    if(localStorage.getItem("RoleType").toString()==UserRole.Admin.toString()){
      this.showOrderDetails=true;
    }
    else{
      this.showOrderDetails=false;
    }
  }

  

  dialogConfig = new MatDialogConfig();
  orderHistories: any;

  isRefresh(refresh: boolean) {
    if (refresh === true) this.getDataPage(1);
  }

  protected override async list(
    request: IPagedOrderHistoryResultRequestDto,
    pageNumber: number
  ) {
    if (localStorage.getItem('TestMode') == 'true') {
      this.request.isTestMode = true;
    } else {
      this.request.isTestMode = false;
    }
    this.request.startDate = this.startDate;
    this.request.endDate = this.endDate;
    this.loader = true;
    console.log(this.request);
    await this.service.getOrderReport(this.request).subscribe((res: any) => {
      console.log('orderreport', res);
      this.allrecords=res
      console.log(res.resultDto.items);
      this.orderHistories = res.resultDto.items.map(item=>({
        ...item,
        orderStatus:OrderStatus[item.orderStatus]})
      );
      
      this.OrderCounts = res;
      console.log('order report paging data',res);
      this.showPaging(res.resultDto, pageNumber);
      this.loader = false;
      console.log(res);
    });
  }
  getStatusClass(status: string): string {
    // Processing = 1,
    // OutForDelivery = 2,
    // Delivered = 3,
    // Pending = 4,
    // Canceled = 5,
    // Success = 6,
    switch(status){
      case 'Processing':
      case 'OutForDelivery':
        return 'btn btn-info';
      case 'Delivered':
      return 'btn btn-success';
      case 'Pending':
      return 'btn btn-warning';
      case 'Canceled':
        return 'btn btn-danger';
    }
  }

  onPageChanged(pageNumber: number) {
    this.request = {
      isInvoledDeletedItems: false,
      skipCount: (pageNumber - 1) * 10,
      maxResultCount: 10,
      keyword: '',
      startDate: '',
      endDate: '',
      isTestMode: false,
    };
    if (localStorage.getItem('TestMode') == 'true') {
      this.request.isTestMode = true;
    } else {
      this.request.isTestMode = false;
    }
    this.list(this.request, pageNumber);
    this.getDataPage(pageNumber);
  }

  onChangeFilter() {
    // this.getDataPage(1);
  }

  Filter(keyword) {
    
    console.log(keyword,'keyweeeeee');
    this.request = {
      keyword: keyword,
      isInvoledDeletedItems: false,
      skipCount: 0,
      maxResultCount: 10,
      startDate: this.startDate,
      endDate: this.endDate,
      isTestMode: false,
    };
    if (localStorage.getItem('TestMode') == 'true') {
      this.request.isTestMode = true;
    } else {
      this.request.isTestMode = false;
    }
    if (this.retailerId > 0) {
      this.request.retailerId = this.retailerId;
    }
    console.log(this.request);
    this.list(this.request, 1);
    // this.service.getOrderHistories(this.request).subscribe((res: any) => {
    //   this.orderHistories = res.items;
    //   this.showPaging(res, 1)
    // })
  }
  getRetailers() {
    var request = {
      isInvloveDeletedItems: false,
      skipCount: 0,
      maxResultCount: 100,
      Keyword: '',
    };
    this.loader = true;
    this.retailerService.GetRetailers(request).subscribe((res: any) => {
      this.Retailers = res.items;
      this.ddlRetailer = res.items;
      this.loader = false;
    });
  }

  filterRetailers(filterValue) {
    this.Retailers = this.ddlRetailer;
    console.log(filterValue.value);
    if (filterValue.value === null) {
      this.retailerId = 0;
      console.log('No retailer selected');
    } else {
      this.retailerId = filterValue.value;
      console.log(filterValue.value);
    }
    // var filter
    // filter = this.Retailers.filter(m => m.fullName.toString().toLowerCase().includes(filterValue.value.toString().toLowerCase()));
    // // this.Retailers=[]
    // this.Retailers=filter
    // console.log(filter)
    // if(filterValue.value=="" || filterValue.value==null){
    //   this.getRetailers()
    // }
    // if(filter==""){
    //   return
    // }
    return;
  }
  onSelectChange(selectedValue) {
    console.log(selectedValue.value);
    selectedValue = selectedValue.value;
    const today = new Date();
    const dayOfWeek = today.getDay();
    const year = today.getFullYear();
    const month = today.getMonth();
    const diff = today.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1);
    const mondayOfWeek = new Date(today.setDate(diff));
    this.boolCustom = false;
    switch (selectedValue) {
      case '1': // Today
        this.startDate = new Date();
        this.endDate = new Date();
        break;
      case '2': // Yesterday
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        this.startDate = yesterday;
        this.endDate = yesterday;
        break;
      case '3': // This week
        this.startDate = mondayOfWeek; // Set start date to Monday
        const endOfWeek = new Date(mondayOfWeek); // Create a new Date for the end of the week
        endOfWeek.setDate(mondayOfWeek.getDate() + 6); // Set to Sunday
        this.endDate = endOfWeek; // Set end date
        console.log(this.endDate);
        break;
      case '4': // Last Week
        const lastMonday = new Date(mondayOfWeek);
        lastMonday.setDate(lastMonday.getDate() - 7);
        const lastSunday = new Date(mondayOfWeek);
        lastSunday.setDate(lastSunday.getDate() - 1);
        this.startDate = lastMonday;
        this.endDate = lastSunday;
        break;
      case '5': // This Month
        const firstDayOfMonth = new Date(year, month, 1);
        const lastDayOfMonth = new Date(year, month + 1, 0);
        this.startDate = firstDayOfMonth;
        this.endDate = lastDayOfMonth;
        break;
      case '6': // Last Month
        const firstDayOfLastMonth = new Date(year, month - 1, 1);
        const lastDayOfLastMonth = new Date(year, month, 0);
        this.startDate = firstDayOfLastMonth;
        this.endDate = lastDayOfLastMonth;
        break;
      case '7': // Custom
        this.boolCustom = true;
        this.startDate = null;
        this.endDate = null;
        break;

      default:
        this.startDate = new Date();
        this.endDate = new Date();
        break;
    }
  }

  itemDetails(orderNumber: string) {
    // Store orderNumber in localStorage
    localStorage.setItem('orderNumber', orderNumber);
    // Open the Angular Material dialog
    const dialogRef = this.dialog.open(OrderItemsComponent, {
      width: '600px', // Adjust width as needed
      minHeight: '400px', // Minimum height to make sure it looks good
      panelClass: 'custom-dialog-container', // Custom class for additional styling
      disableClose: true, // Prevent closing by clicking outside
      data: { orderNumber: orderNumber }, // Pass the order number to the modal
    });

    // Handle dialog close event
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.refresh) {
        this.isRefresh(true);
      }
    });
  }

  NavigateToUpdateStatus(ordernumber, orderstatus) {
    if (orderstatus != 3 && orderstatus != 5) {
      localStorage.setItem('orderNumberStatus', ordernumber);
      localStorage.setItem('oldStatus', orderstatus);

      // Open the Angular Material dialog
      const dialogRef = this.dialog.open(UpdateOrderStatusComponent, {
        width: '600px', // Adjust width as needed
        minHeight: '400px', // Minimum height to make sure it looks good
        panelClass: 'custom-dialog-container', // Custom class for additional styling
        disableClose: true, // Prevent closing by clicking outside
        data: { ordernumber: ordernumber, orderstatus: orderstatus }, // Pass the order number to the modal
      });

      // Handle dialog close event
      dialogRef.afterClosed().subscribe((result) => {
        if (result && result.refresh) {
          this.isRefresh(true);
        }
      });
      ordernumber.clear();
      orderstatus.clear();
      this.loader = false;
    }
  }
  PrintRecipt(ordernumber) {
    let urlTree = this.router.createUrlTree([environment.appNameUrl+`printrecipt/delivery-report/id${ordernumber}`], { queryParams:{
      retailerid:this.retailerId!=null ? this.retailerId:0,
      startDate:this.startDate,
      endDate:this.endDate,
      keyword:this.keyword
    } });
    let url = this.router.serializeUrl(urlTree);
    this.loader=false;
    // Open in a new tab
    window.open(url, '_blank');
  }
  printAllRecords() {
    // Gather filter data
    this.loader = true;
    let urlTree = this.router.createUrlTree([environment.appNameUrl +'/printrecipt/delivery-report-bulk'], { queryParams:{
      retailerid:this.retailerId!=null ? this.retailerId:0,
      startDate:this.startDate.toISOString(),
      endDate:this.endDate.toISOString(),
      keyword:this.keyword
    } });
    let url = this.router.serializeUrl(urlTree);
    this.loader=false;
    // Open in a new tab
    window.open(url, '_blank');
    
  }
  
  exportToCSV() {
    this.loader = true;
    this.request={
      startDate:this.startDate,
      endDate:this.endDate,
      skipCount:0,
      maxResultCount:100000
    }
    this.service.getOrderReport(this.request).subscribe((res: any) => {
      this.data = res.resultDto.items;
      if (this.data.length === 0) return;

      const csvHeaders = [
          'Date',
        'Sender Name',
        'Sender Phone',
        'Rec Name',
        'Rec PhoneNumber',
        'Retailer',
        'Discount',
        'Discounted Amount',
        'Total Amount',
        'Order Number',
        'Order Status ',
      ];
      const statusMapping = {
        1: 'Processing',
        2: 'Out for Delivery',
        3: 'Delivered',
        4: 'Pending',
        5: 'Cancelled',
      };

      const csvRows = [];
      csvRows.push(csvHeaders.join(','));

      for (const row of this.data) {
        const rowData = [
          row.orderDate,
          row.senderName,
          row.senderPhone,
          row.receiverName,
          row.receiverPhone,
          row.retailerName,
          row.totalDiscount,
          row.totalDiscountedAmount,
          row.totalAmount,
          row.orderNumber,
          statusMapping[row.orderStatus],
        ];

        csvRows.push(rowData.map((field) => JSON.stringify(field)).join(','));
      }

      const csvBlob = new Blob([csvRows.join('\n')], {
        type: 'text/csv;charset=utf-8;',
      });
      saveAs(csvBlob, 'data.csv');
      this.loader = false;
    });
  }
  exportDataPDF() {
    // this.request.maxResultCount=this.totalItemsCount
    this.loader = true;
    this.request={
      startDate:this.startDate,
      endDate:this.endDate,
      skipCount:0,
      maxResultCount:100000
    }
    this.service.getOrderReport(this.request).subscribe((res: any) => {
      this.data = res.resultDto.items;
      this.exportToPDF(this.data, 'Order History.pdf');
    });
  }
  exportToPDF(data: any[], filename: string) {
    const doc = new jsPDF();

    if (data.length === 0) {
      doc.text('No data available', 14, 16);
      doc.save(filename);
      return;
    }

    const pdfHeaders = [
      'Date',
      'Sender Name',
      'Sender Phone',
      'Rec Name',
      'Rec PhoneNumber',
      'Retailer',
      'Discount',
      'Discounted Amount',
      'Total Amount',
      'Order Number',
      'Order Status ',
    ];
    const statusMapping = {
      1: 'Processing',
      2: 'Out for Delivery',
      3: 'Delivered',
      4: 'Pending',
      5: 'Cancelled',
    };

    const tableData = data.map((row) => [
      row.orderDate,
      row.senderName,
      row.senderPhone,
      row.receiverName,
      row.receiverPhone,
      row.retailerName,
      row.totalDiscount,
      row.totalDiscountedAmount,
      row.totalAmount,
      row.orderNumber,
      statusMapping[row.orderStatus],
      row.orderNumber,
    ]);

    doc.text('Order History', 14, 16);

    (doc as any).autoTable({
      head: [pdfHeaders],
      body: tableData,
      startY: 22,
      styles: { fontSize: 7 },
    });

    doc.save(filename);
    this.loader = false;
  }
  // logout() {
  //   this.loginService.logout();
  // }
  //  PrintRecipt(ordernumber){
  //   const url=this.router.serializeUrl(
  //      this.router.createUrlTree([this.baseURL+`printrecipt/print/id${ordernumber}`])
  //     //this.router.createUrlTree([`/PridAppLive/printrecipt/id${ordernumber}`])
  //     // this.router.createUrlTree([`/printrecipt/id${ordernumber}`])

  //   )
  //   window.open(url,'_blank')
  // }
  // order = {
  //   orderStatus: OrderStatus.Processing,  // Using OrderStatus enum here
  //   remarks: 'Your order is being processed.',
  // };
   
  getOrderStatusLabel(status: string): string {
    return OrderStatus[status]; // Use the utility function to get the label
  }
}
